// extracted by mini-css-extract-plugin
module.exports = {"root":"EditResultCorrects_root__3Ft2M","fieldContainer":"EditResultCorrects_fieldContainer__17cJ7"};